import FieldFormTemplateModule from './fields.form.template';





export default FieldFormTemplateModule.extend( {

    template: 'module/refbooks/fields.form.bound-stickers',

    url() {
        return this.model.id
            ? `fields/${this.model.id}/edit/bound-stickers`
            : `fields/new/bound-stickers`;
    },

    open({ field, original }) {
        const {
            stickersPage = 1, stickersLimit = 10,
            stickersSort = 'title', stickersDirection = 'asc',
            stickersSearch = '',
        } = this.state() || {};

        this.setState( { 
            stickersPage, stickersLimit, stickersSort, stickersDirection, stickersSearch,
        } );

        return FieldFormTemplateModule.prototype.open.call( this, { field, original } );
    },

    finalizeOpen(field) {
        return this.bind( field );
    },

    finalizeStart(field) {
        this.listenTo( field, 'change:cluster', () => {
            console.log( 'cluster changed' );
            this.setState( { stickersPage: 1, } );
            this.Stickers.options.page = 1;
            // render() doesn't re-filter models but reFilterGrid() does
            this.Stickers.reFilterGrid();
            this.navigated();
        } );

        this.listenTo( field, 'change:format', () => {
            if (field.get( 'format' ) !== 'file' )
                this.setState( { stickersPage: 1, stickersSearch: '', stickersSort: 'title', stickersDirection: 'asc' } ),
                this.trigger( FieldFormTemplateModule.TOGGLE_BOUND_TYPES,
                        this.model,
                        this.originalModel,
                        this.state() );
        } );
    },

    serialize() {
        const { 
            stickersSort, stickersDirection, stickersSearch, stickersPage,
        } = this.state();

        return {
            stickersSort, stickersDirection, stickersSearch, stickersPage,
            hasDiff: () => this.hasDiff(),
        };
    },

    [FieldFormTemplateModule.event( 'Stickers:page')](page) {
        return this.setState( { stickersPage: +page, } ), 
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'Stickers:sort')]({ sort, direction }) {
        return this.setState( { stickersSort: sort, stickersDirection: direction, } ), 
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'Stickers:search')](search) {
        return this.setState( { stickersSearch: search, stickersPage: 1, } ), 
            this.navigated();
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.bound-stickers.js